<google-map class="cars-map" width="100%" [center]="center" [zoom]="zoom" [mapId]="mapId" [options]="options">
</google-map>
